const StandardSpinner = ()=>{
    return (
      <div className="flex items-center justify-center min-h-screen text-white bg-gray-200 dark:bg-richblue-950">
        <div className="text-center">
          <div className="w-16 h-16 mx-auto mb-4 border-4 rounded-full border-gray-500/30 dark:border-blue-500/30 border-t-gray-300 dark:border-t-blue-500 animate-spin"></div>
          <p className="text-gray-700 dark:text-blue-300/70">Loading subscription data...</p>
        </div>
      </div>
    );
}
export default StandardSpinner;